/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  CLEAR_ERROR_MSG,
  ERROR_MSG,
  GET_ENTERPRISE_LIST,
  GET_USER_LIST,
  GET_RAISED_ISSUE_DETAILS,
  GET_RAISED_ISSUE_HISTORY,
  GET_RAISED_ISSUE_LIST,
  LOADER,
  UPDATE_RAISED_ISSUE_STATUS
} from 'src/actions/raisedIssueAction';

const initialState = {
  isLoading: false,
  raisedIssueList: [],
  raisedIssueTotalRecord: 0,
  raisedIssueTotalPages: 0,
  errorMessage: '',
  raisedIssueDetails: null,
  raisedIssueHistory: null,
  enterpriseList: [],
  userList: []
};

const raisedIssueReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER: {
      return produce(state, draft => {
        draft.isLoading = true;
      });
    }

    case GET_RAISED_ISSUE_LIST: {
      const data = action.payload;

      return produce(state, draft => {
        draft.raisedIssueList = data?.itemList || [];
        draft.raisedIssueTotalRecord = data?.pagination?.totalElements || 0;
        draft.raisedIssueTotalPages = data?.pagination?.totalPages || 0;
        draft.isLoading = false;
      });
    }

    case ERROR_MSG: {
      return produce(state, draft => {
        draft.isLoading = false;
        draft.errorMessage =
          action.payload?.message ||
          action.payload?.errorMessage ||
          action.payload?.error ||
          'Something went wrong. Contact tech team.';
      });
    }

    case CLEAR_ERROR_MSG: {
      return produce(state, draft => {
        draft.errorMessage = '';
      });
    }

    case GET_RAISED_ISSUE_DETAILS: {
      const data = action.payload;

      return produce(state, draft => {
        draft.raisedIssueDetails = data || null;
        draft.isLoading = false;
      });
    }

    case UPDATE_RAISED_ISSUE_STATUS: {
      const data = action.payload;
      return produce(state, draft => {
        draft.isLoading = false;
      });
    }

    case GET_RAISED_ISSUE_HISTORY: {
      const data = action.payload;
      return produce(state, draft => {
        draft.raisedIssueHistory = data || null;
        draft.isLoading = false;
      });
    }

    case GET_ENTERPRISE_LIST: {
      const data = action.payload;
      return produce(state, draft => {
        draft.enterpriseList = data || [];
      });
    }

    case GET_USER_LIST: {
      const data = action.payload;
      return produce(state, draft => {
        draft.userList = data || [];
      });
    }

    default: {
      return state;
    }
  }
};

export default raisedIssueReducer;
